import React, { useState } from "react";
import PropTypes from "prop-types";
import { requestPostFetchApi } from "utils/apiMethods";
import "components/Button/Button.css";
import { disablePointerEvents, enablePointerEvents } from "utils/commonMethods";

//Handles all type of button available in app.
function LoadingButton() {
  //Dynamically setting class name of button.
  let customButtonClassName = "custom-button outer-shadow";
  customButtonClassName += " with-loader fcolor--secondary";

  customButtonClassName += " show-loader";

  return (
    <div className={"custom-button__wrapper "}>
      <button className={customButtonClassName}>
        {<div className="loading-dots"></div>}
      </button>
    </div>
  );
}

export default LoadingButton;
